module.exports = __webpack_public_path__ + "img/logo.ee76a1d8.png";